<template>
  <div id="app">
    <router-view name="header" />
    <div class="wrapper">
      <router-view />
    </div>
    <router-view name="footer" />
    <button
      v-show="showTopButton"
      class="top-button"
      type="button"
      aria-label="맨 위로 이동"
      @click="scrollToTop"
    >
      <i class="now-ui-icons arrows-1_minimal-up"></i>
      <span>TOP</span>
    </button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showTopButton: false
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.showTopButton = window.pageYOffset > 320;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
};
</script>
<style scoped>
.top-button {
  position: fixed;
  right: 28px;
  bottom: 28px;
  z-index: 1050;
  display: inline-flex;
  width: 58px;
  height: 58px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 2px;
  border: 0;
  border-radius: 50%;
  background: #2ca8ff;
  color: #fff;
  box-shadow: 0 14px 34px rgba(44, 168, 255, 0.36);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.top-button:hover,
.top-button:focus {
  background: #1683d8;
  box-shadow: 0 18px 38px rgba(22, 131, 216, 0.4);
  color: #fff;
  outline: 0;
  transform: translateY(-3px);
}

.top-button i {
  font-size: 1rem;
  line-height: 1;
}

.top-button span {
  font-size: 0.68rem;
  font-weight: 800;
  line-height: 1;
}

@media (max-width: 767px) {
  .top-button {
    right: 18px;
    bottom: 18px;
    width: 52px;
    height: 52px;
  }
}
</style>
